<div class="client-container d-flex flex-column">

    <div class="view">
        <!-- Tabs -->
        <mat-tab-group #matTabGroup [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
            <mat-tab [disabled]="true">
                <ng-template mat-tab-label>
                    <div class="tab-header-label">
                        <span class="category"><small>Conversations</small></span>
                        <span class="object-name">List</span>
                    </div>
                </ng-template>
                <!-- No content required -->
            </mat-tab>
            <mat-tab label="Overview">
                <div class="tab-content">
                    <!-- Tag Chiplist -->
                    <div class="tag-filter">
                        <mat-chip-listbox aria-label="Tag Filter" [multiple]="false">
                            <mat-chip-option (click)="applyTagFilter(null)"
                                             [selected]="!selectedTag"
                                             class="tag-chip"
                                             [attr.aria-label]="getTagAriaLabel(null)">
                                {{ getTagDisplayLabel(null) }}
                            </mat-chip-option>
                            @for (tag of displayedTags; track tag) {
                                <mat-chip-option
                                        (click)="applyTagFilter(tag)"
                                        [attr.aria-label]="getTagAriaLabel(tag)"
                                        [selected]="selectedTag === tag"
                                        class="tag-chip">
                                    {{ getTagDisplayLabel(tag) }}
                                </mat-chip-option>
                            }
                            @if (hasMoreTags) {
                                <button [matMenuTriggerFor]="tagMenu" class="more-tags-button"
                                        mat-button>
                                    More Tags...
                                </button>
                            }
                            <mat-menu #tagMenu="matMenu" class="tag-menu">
                                @for (tag of hiddenTags; track tag) {
                                    <button (click)="applyTagFilter(tag)" [attr.aria-label]="getTagAriaLabel(tag)"
                                            mat-menu-item>
                                        {{ getTagDisplayLabel(tag) }}
                                    </button>
                                }
                            </mat-menu>
                        </mat-chip-listbox>
                    </div>
                    <!-- Filter Controls -->
                    <div class="filter-controls">
                        <!-- Search Field -->
                        <mat-form-field appearance="outline" class="search-field">
                            <mat-label>Search</mat-label>
                            <input [formControl]="searchControl" matInput placeholder="Search conversations">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>

                        <!-- Chatbot Filter -->
                        <mat-form-field appearance="outline" class="chatbot-filter">
                            <mat-label>Chatbot</mat-label>
                            <mat-select [formControl]="chatbotControl">
                                <mat-option value="all">All chatbots</mat-option>
                                @for (option of chatbotOptions; track option.id) {
                                    <mat-option [value]="option.id">
                                        {{ option.name }}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-icon matSuffix>smart_toy</mat-icon>
                        </mat-form-field>

                        <!-- Feedback Filter -->
                        <mat-form-field appearance="outline" class="feedback-filter">
                            <mat-label>Feedback</mat-label>
                            <mat-select [formControl]="feedbackControl">
                                @for (option of feedbackOptions; track option.value) {
                                    <mat-option [value]="option.value">
                                        {{ option.viewValue }}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-icon matSuffix>thumbs_up_down</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="category-filter">
                            <mat-label>Category</mat-label>
                            <mat-select [formControl]="categoryControl">
                                @for (option of categoryOptions; track option.value) {
                                    <mat-option [value]="option.value">
                                        {{ option.viewValue }}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-icon matSuffix>category</mat-icon>
                        </mat-form-field>

                        <!-- Date Range Filter -->
                        <mat-form-field appearance="outline" class="date-filter">
                            <mat-label>Date Range</mat-label>
                            <mat-select [formControl]="dateRangeControl"
                                        (openedChange)="dateRangeSelectOpen = $event">
                                @for (option of dateRangeOptions; track option.value) {
                                    <mat-option [value]="option.value">
                                        {{ option.viewValue }}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-icon matSuffix>date_range</mat-icon>
                        </mat-form-field>
                    </div>

                    @if (showCustomDateRangeControls()) {
                        <div class="custom-date-range-controls">
                            <mat-form-field appearance="outline" class="custom-date-filter">
                                <mat-label>From</mat-label>
                                <input
                                        [formControl]="customStartDateControl"
                                        [matDatepicker]="customStartDatePicker"
                                        aria-label="Custom date range start date"
                                        matInput
                                        placeholder="Start date">
                                <mat-datepicker-toggle [for]="customStartDatePicker" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #customStartDatePicker></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="custom-date-filter">
                                <mat-label>To</mat-label>
                                <input
                                        [formControl]="customEndDateControl"
                                        [matDatepicker]="customEndDatePicker"
                                        aria-label="Custom date range end date"
                                        matInput
                                        placeholder="End date">
                                <mat-datepicker-toggle [for]="customEndDatePicker" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #customEndDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    }

                    <div class="conversation-export-actions">
                        <span class="export-count" aria-live="polite">
                            {{ dataSource.filteredData.length }} {{ dataSource.filteredData.length === 1 ? 'conversation matches' : 'conversations match' }} the filters
                        </span>
                        <button mat-stroked-button color="primary" [matMenuTriggerFor]="exportMenu"
                                (menuOpened)="prepareConversationExports()" (menuClosed)="releaseConversationExports()"
                                [disabled]="!canExportConversations" aria-label="Export filtered conversations">
                            <mat-icon>download</mat-icon>
                            Export
                        </button>
                        <mat-menu #exportMenu="matMenu">
                            <a mat-menu-item [href]="exportDownloads.csv?.url" [attr.download]="exportDownloads.csv?.fileName"
                               [disabled]="!canExportConversations || !exportDownloads.csv">CSV (Excel)</a>
                            <a mat-menu-item [href]="exportDownloads.json?.url" [attr.download]="exportDownloads.json?.fileName"
                               [disabled]="!canExportConversations || !exportDownloads.json">JSON</a>
                        </mat-menu>
                    </div>

                    @if (isLoadingConversations) {
                        <mat-progress-bar
                                aria-label="Loading conversations"
                                class="conversation-loading-bar"
                                mode="indeterminate">
                        </mat-progress-bar>
                    }

                    <ng-template #conversationDetail let-row>
                        <mat-card class="detail-card">
                            <mat-card-header>
                                <mat-card-title>Review conversation</mat-card-title>
                                <mat-card-subtitle>
                                    {{ row.email || 'Anonymous visitor' }} · {{ getChatbotDisplayName(row) }} · {{ row.lastModified | date:'medium' }}
                                </mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="detail-actions" aria-label="Conversation actions">
                                    <button (click)="previewInWidget(row)"
                                            [disabled]="!row.clientId || !row.shopAssistantId"
                                            color="primary" mat-flat-button>
                                        <mat-icon>smart_toy</mat-icon>
                                        Åpne i chatbot
                                    </button>
                                    <button (click)="copyConversationLink(row)" mat-stroked-button>
                                        <mat-icon>link</mat-icon>
                                        Copy link
                                    </button>
                                    @if (!row.approved && !row.dismissed) {
                                        <button (click)="approveThread(row)" color="primary" mat-stroked-button>
                                            <mat-icon>check_circle</mat-icon>
                                            Approve
                                        </button>
                                    }
                                    @if (!row.approved && !row.dismissed) {
                                        <button (click)="declineThread(row)" mat-stroked-button>
                                            <mat-icon>block</mat-icon>
                                            Decline
                                        </button>
                                    }
                                    <button (click)="deleteThread(row)"
                                            [disabled]="deletingThreadId === row.id"
                                            color="warn" mat-stroked-button>
                                        <mat-icon>delete</mat-icon>
                                        {{ deletingThreadId === row.id ? 'Deleting...' : 'Delete' }}
                                    </button>
                                    @if (row.approved) {
                                        <span aria-label="Approved" class="status-icon approved" matTooltip="Approved">
                                                            <mat-icon>check_circle</mat-icon>
                                                            Approved
                                                        </span>
                                    }
                                    @if (row.dismissed) {
                                        <span aria-label="Dismissed" class="status-icon dismissed" matTooltip="Dismissed">
                                                            <mat-icon>block</mat-icon>
                                                            Dismissed
                                                        </span>
                                    }
                                </div>
                                <div class="review-summary">
                                                    <span class="status-pill" [ngClass]="row.approved ? 'approved' : ''">
                                                        <mat-icon>{{ row.approved ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                                                        {{ row.approved ? 'Approved' : 'Needs review' }}
                                                    </span>
                                    @if (row.dismissed) {
                                        <span class="status-pill dismissed">
                                                            <mat-icon>block</mat-icon>
                                                            Dismissed
                                                        </span>
                                    }
                                    <span class="status-pill">
                                                        <mat-icon>category</mat-icon>
                                                        {{ getCategoryDisplayName(row) }}
                                                    </span>
                                    <span class="status-pill">
                                                        <mat-icon>thumbs_up_down</mat-icon>
                                                        {{ getFeedbackLabel(row) }}
                                                    </span>
                                    <span class="status-pill">
                                                        <mat-icon>forum</mat-icon>
                                                        {{ getMessageCount(row, 'user') }} questions · {{ getMessageCount(row, 'assistant') + getMessageCount(row, 'human') }} answers
                                                    </span>
                                    @if (row.tags.length) {
                                        @for (tag of row.tags; track tag) {
                                            <span class="metadata-chip">{{ tag }}</span>
                                        }
                                    }
                                </div>

                                <section class="conversation-review" aria-label="Questions and answers">
                                    @for (msg of row.messages; track msg) {
                                        <article class="message-entry" [ngClass]="msg.user ? 'question' : 'answer'">
                                            <div class="message-entry-header">
                                                                <span class="message-role">
                                                                    <mat-icon>{{ msg.user ? 'person' : (msg.human ? 'support_agent' : 'smart_toy') }}</mat-icon>
                                                                    {{ msg.user ? 'Question' : (msg.human ? 'Agent answer' : 'Answer') }}
                                                                </span>
                                                @if (msg.assistantId) {
                                                    <span class="assistant-routing"
                                                          [matTooltip]="getAssistantSelectionTooltip(msg)"
                                                          matTooltipPosition="above">
                                                                        <mat-icon>smart_toy</mat-icon>
                                                        {{ getAssistantDisplayName(msg.assistantId) }}
                                                                    </span>
                                                }
                                                @if (msg.timestampUtc) {
                                                    <span class="message-time">{{ msg.timestampUtc | date: 'short' }}</span>
                                                }
                                            </div>
                                            <app-conversation-transcript-renderer
                                                    [chatbot]="getChatbotOptions(row)"
                                                    [conversationId]="row.id"
                                                    [message]="msg">
                                            </app-conversation-transcript-renderer>
                                        </article>
                                    }
                                </section>

                                <mat-accordion class="supporting-details" [multi]="false">
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>Conversation context</mat-panel-title>
                                            <mat-panel-description>Page and timing</mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class="context-grid">
                                            <div>
                                                <span class="context-label">Started</span>
                                                <strong>{{ row.created | date: 'medium' }}</strong>
                                            </div>
                                            <div>
                                                <span class="context-label">Last activity</span>
                                                <strong>{{ row.lastModified | date: 'medium' }}</strong>
                                            </div>
                                            <div>
                                                <span class="context-label">Duration</span>
                                                <strong>{{ getDurationLabel(row) }}</strong>
                                            </div>
                                            <div>
                                                <span class="context-label">Chatbot</span>
                                                <strong>{{ getChatbotDisplayName(row) }}</strong>
                                            </div>
                                        </div>
                                        @if (getLastUserMessage(row); as lastUserMessage) {
                                            <div class="page-context">
                                                <p><strong>Page:</strong> {{ lastUserMessage.pageTitle || '—' }}</p>
                                                @if (lastUserMessage.pageUrl) {
                                                    <p><strong>URL:</strong> <a [href]="lastUserMessage.pageUrl" target="_blank">{{ getCleanUrl(lastUserMessage.pageUrl) }}</a></p>
                                                }
                                                @if (lastUserMessage.referrer) {
                                                    <p><strong>Referrer:</strong> {{ getCleanUrl(lastUserMessage.referrer) }}</p>
                                                }
                                            </div>
                                        }
                                    </mat-expansion-panel>

                                    @if (hasAnswerProductionDetails(row)) {
                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>How answers were produced</mat-panel-title>
                                                <mat-panel-description>Routing, tools and references</mat-panel-description>
                                            </mat-expansion-panel-header>
                                            @for (msg of row.messages; track msg) {
                                                @if (!msg.user && (msg.assistantSelectionReason || msg.functionsCalled?.length || msg.uiUpdates?.length)) {
                                                    <div class="provenance-block">
                                                        @if (msg.assistantSelectionReason) {
                                                            <p><strong>Routing:</strong> {{ msg.assistantSelectionReason }}</p>
                                                        }
                                                        @if (msg.functionsCalled?.length) {
                                                            <p><strong>Tools used:</strong></p>
                                                            <ul class="compact-list">
                                                                @for (fn of msg.functionsCalled; track fn) {
                                                                    <li>
                                                                        <span class="fn-name">{{ fn.name }}</span>
                                                                        @if (fn.functionType) {
                                                                            <span class="muted"> · {{ fn.functionType }}</span>
                                                                        }
                                                                        @if (getFunctionInputRows(row, fn); as inputRows) {
                                                                            @if (inputRows.length) {
                                                                                <details class="function-inputs">
                                                                                    <summary>Input used</summary>
                                                                                    <dl>
                                                                                        @for (input of inputRows; track input.label) {
                                                                                            <dt>{{ input.label }}</dt>
                                                                                            <dd>{{ input.value }}</dd>
                                                                                        }
                                                                                    </dl>
                                                                                </details>
                                                                            }
                                                                        }
                                                                    </li>
                                                                }
                                                            </ul>
                                                        }
                                                        @if (msg.uiUpdates?.length) {
                                                            <p><strong>UI updates:</strong></p>
                                                            <ul class="compact-list">
                                                                @for (update of msg.uiUpdates; track update) {
                                                                    <li>
                                                                        <span class="fn-name">{{ update['function'] }}</span>
                                                                        @if (update.displayMode) {
                                                                            <span class="muted"> · {{ update.displayMode }}</span>
                                                                        }
                                                                    </li>
                                                                }
                                                            </ul>
                                                        }
                                                    </div>
                                                }
                                            }
                                            @if (getModelReferenceEvents(row).length) {
                                                <div class="provenance-block">
                                                    <p><strong>References used:</strong></p>
                                                    <ul class="compact-list">
                                                        @for (referenceEvent of getModelReferenceEvents(row); track referenceEvent) {
                                                            <li>
                                                                @if (referenceEvent.reference; as reference) {
                                                                    @if (reference.url) {
                                                                        <a [href]="reference.url" target="_blank">{{ getReferenceLabel(referenceEvent) }}</a>
                                                                    } @else {
                                                                        <span>{{ getReferenceLabel(referenceEvent) }}</span>
                                                                    }
                                                                    <span class="muted"> · {{ reference.source || 'source' }}</span>
                                                                }
                                                            </li>
                                                        }
                                                    </ul>
                                                </div>
                                            }
                                        </mat-expansion-panel>
                                    }

                                    @if (row.errorMessages?.length || row.blockedAsIrrelevant) {
                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>Quality signals</mat-panel-title>
                                                <mat-panel-description>Only when something needs attention</mat-panel-description>
                                            </mat-expansion-panel-header>
                                            @if (row.blockedAsIrrelevant) {
                                                <p>One or more messages were blocked as irrelevant.</p>
                                            }
                                            @if (row.errorMessages?.length) {
                                                <ul class="compact-list">
                                                    @for (error of row.errorMessages; track error) {
                                                        <li>{{ error }}</li>
                                                    }
                                                </ul>
                                            }
                                        </mat-expansion-panel>
                                    }
                                </mat-accordion>
                            </mat-card-content>
                        </mat-card>
                    </ng-template>

                    <div class="mobile-conversations-list m-t-30" aria-label="Mobile conversations">
                        @for (row of getVisibleConversations(); track row.id) {
                            <mat-card class="conversation-card">
                                <mat-card-content>
                                    <div class="conversation-card-header">
                                        <div>
                                            <div class="conversation-card-title">{{ row.email || 'Anonymous visitor' }}</div>
                                            <div class="conversation-card-subtitle">
                                                {{ getLastUserMessage(row)?.pageTitle || 'No page title' }}
                                            </div>
                                        </div>
                                        <button mat-icon-button
                                                (click)="toggleExpand(row)"
                                                [attr.aria-expanded]="isConversationExpanded(row)"
                                                [attr.aria-label]="isConversationExpanded(row) ? 'Collapse conversation details' : 'Expand conversation details'">
                                            <mat-icon>{{ isConversationExpanded(row) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                        </button>
                                    </div>

                                    <div class="conversation-card-summary">
                                        <span class="status-pill">
                                            <mat-icon>forum</mat-icon>
                                            {{ row.messages.length }} messages
                                        </span>
                                        <span class="status-pill">
                                            <mat-icon>category</mat-icon>
                                            {{ getCategoryDisplayName(row) }}
                                        </span>
                                        <span class="status-pill">
                                            <mat-icon>thumbs_up_down</mat-icon>
                                            {{ getFeedbackLabel(row) }}
                                        </span>
                                    </div>

                                    <dl class="conversation-card-metadata">
                                        <div>
                                            <dt>Chatbot</dt>
                                            <dd>{{ getChatbotDisplayName(row) }}</dd>
                                        </div>
                                        <div>
                                            <dt>Created</dt>
                                            <dd>{{ row.created | date:'dd/MM/yyyy' }}</dd>
                                        </div>
                                        <div>
                                            <dt>Page URL</dt>
                                            <dd>{{ getLastUserMessage(row)?.pageTitle || '—' }}</dd>
                                        </div>
                                        @if (row.tags.length) {
                                            <div>
                                                <dt>Tags</dt>
                                                <dd class="conversation-card-tags">
                                                    @for (tag of row.tags; track tag) {
                                                        <span class="metadata-chip">{{ tag }}</span>
                                                    }
                                                </dd>
                                            </div>
                                        }
                                    </dl>

                                    @if (isConversationExpanded(row)) {
                                        <div class="conversation-card-detail">
                                            <ng-container [ngTemplateOutlet]="conversationDetail"
                                                          [ngTemplateOutletContext]="{$implicit: row}">
                                            </ng-container>
                                        </div>
                                    }
                                </mat-card-content>
                            </mat-card>
                        }
                    </div>

                    <!-- Table -->
                    <div class="table-responsive m-t-30">
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows
                               matSort matSortActive="created" matSortDirection="desc" matSortDisableClear>

                            <!-- Number of Chats Column -->
                            <ng-container matColumnDef="numberOfChats">
                                <th mat-header-cell *matHeaderCellDef># of messages</th>
                                <td *matCellDef="let element" mat-cell> {{ element.messages.length }}</td>
                            </ng-container>

                            <!-- Page URL Column -->
                            <ng-container matColumnDef="pageTitle">
                                <th mat-header-cell *matHeaderCellDef>Page URL</th>
                                <!-- display the last user message url parameter. Need to filter out messages that have user = false to find the correct index-->
                                <td *matCellDef="let element" mat-cell> {{ getLastUserMessage(element)?.pageTitle }}
                                </td>
                            </ng-container>

                            <!-- Chatbot Column -->
                            <ng-container matColumnDef="chatbot">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Chatbot</th>
                                <td *matCellDef="let element" mat-cell>
                                    {{ getChatbotDisplayName(element) }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="category">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
                                <td *matCellDef="let element" mat-cell>
                                    {{ getCategoryDisplayName(element) }}
                                </td>
                            </ng-container>

                            <!-- Feedback Column -->
                            <ng-container matColumnDef="feedback">
                                <th mat-header-cell *matHeaderCellDef>Feedback</th>
                                <td mat-cell *matCellDef="let element">
                                    @if (element.thumbUp) {
                                        <mat-icon color="primary" aria-label="thumbs up">thumb_up</mat-icon>
                                    } @else {
                                        @if (element.thumbDown) {
                                            <mat-icon color="warn" aria-label="thumbs down">thumb_down</mat-icon>
                                        } @else {
                                            <span class="text-muted">—</span>
                                        }
                                    }
                                </td>
                            </ng-container>

                            <!-- Created Column -->
                            <ng-container matColumnDef="created">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                                <td *matCellDef="let element" mat-cell> {{ element.created | date:'dd/MM/yyyy' }}</td>
                            </ng-container>

                            <!-- Expand Column -->
                            <ng-container matColumnDef="expand">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <button mat-icon-button (click)="toggleExpand(element)" aria-label="Toggle Details">
                                        <mat-icon>
                                            {{ expandedElement === element.id ? 'expand_less' : 'expand_more' }}
                                        </mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <!-- Expanded Detail Row -->
                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length"
                                    class="expanded-detail-cell">
                                    <div [@detailExpand]="row.id === expandedElement ? 'expanded' : 'collapsed'"
                                         class="example-element-detail">
                                        <ng-container [ngTemplateOutlet]="conversationDetail"
                                                      [ngTemplateOutletContext]="{$implicit: row}">
                                        </ng-container>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Header Row -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <!-- Main Data Rows -->
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="main-row"></tr>
                            <!-- Expanded Detail Rows -->
                            <tr *matRowDef="let row; columns: ['expandedDetail'];" [hidden]="expandedElement !== row.id"
                                class="detail-row" mat-row></tr>
                        </table>
                    </div>

                    <!-- Paginator -->
                    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
                </div>
            </mat-tab>
            <mat-tab label="Errors">
                <div class="tab-content">
                    <mat-list>
                        <!-- display a list of all errors that are in masterThread[].ErrorMessages -->
                        @for (error of getErrorMessages(); track error) {
                            <mat-list-item>
                                <div class="error-message">
                                    @if (error && error.length > 0) {
                                        <p matLine>{{ error }}</p>
                                    }
                                </div>
                            </mat-list-item>
                        }
                    </mat-list>
                </div>
            </mat-tab>
            <mat-tab label="Conversation Settings">
                <div class="tab-content conversation-settings-tab">
                    <app-conversation-settings
                            [settings]="conversationSettings"
                            (settingsSaved)="onConversationSettingsSaved($event)">
                    </app-conversation-settings>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
